import { Injectable } from '@angular/core';

import { AppConfig } from '../utils/app-config.service';

@Injectable({
    providedIn: 'root',
})
export class GoogleTagManagerService {
    private isLoaded = false;

    private browserGlobals = {
        windowRef(): any {
            return window;
        },
        documentRef(): any {
            return document;
        },
    };

    public getDataLayer() {
        const window = this.browserGlobals.windowRef();
        window.dataLayer = window.dataLayer || [];
        return window.dataLayer;
    }

    private pushOnDataLayer(obj: object) {
        const dataLayer = this.getDataLayer();
        dataLayer.push(obj);
    }

    public addGtmToDom() {
        const document = this.browserGlobals.documentRef();
        this.pushOnDataLayer({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js',
        });

        const gtmScript = document.createElement('script');
        gtmScript.id = 'GTMscript';
        gtmScript.async = true;
        gtmScript.src = 'https://www.googletagmanager.com/gtm.js?id=' + AppConfig.settings.gtmId;
        document.head.insertBefore(gtmScript, document.head.firstChild);

        const iframe = document.createElement('iframe');
        iframe.setAttribute('src', 'https://www.googletagmanager.com/ns.html?id=' + AppConfig.settings.gtmId);
        iframe.style.width = '0';
        iframe.style.height = '0';
        iframe.style.display = 'none';
        iframe.style.visibility = 'hidden';

        const noscript = document.createElement('noscript');
        noscript.id = 'GTMiframe';
        noscript.appendChild(iframe);

        document.body.insertBefore(noscript, document.body.firstChild);
        this.isLoaded = true;
    }

    public pushTag(item: object) {
        if (!this.isLoaded) {
            this.addGtmToDom();
        }
        this.pushOnDataLayer(item);
    }
}
